import rapidElearningsRoutes from 'modules/trainingLibrary/RapidElearning/routing/routes'

const routes = {
  root: `${rapidElearningsRoutes.root}/details`,
}

export default routes
